// Partner logo URL. SVG logos are served as they are: the /thumb resizer (GD) can't read SVG.
// Raster logos are resized to `size` and sent as WebP (the server falls back to the original format without WebP support).
export default function partnerLogo (photo, size) {
  if (!photo) return `/thumb/resize/${size}/data/partners/unknown.jpg?format=webp`
  if (/\.svg$/i.test(photo)) return `/data/partners/${photo}`
  return `/thumb/resize/${size}/data/partners/${photo}?format=webp`
}
